import useQueryHook from '@/hooks/useQueryHook';

import { API, URLs } from '@/api';

export const GetThumbnailUrl = (questionId?: number) => {
    const { data: thumbnailUrl } = useQueryHook(
        ['ina-question-thumbnail', `${questionId}`],
        async () => {
            if (questionId) return API.get(URLs.ina.thumbnail(questionId));
        },
        {
            onSuccess: res => {},
            cacheTime: 0,
            staleTime: 0,
        },
    );

    return { thumbnailUrl };
};
